import { Link } from "react-router-dom";

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
}

export default function SectionTitle({ title, subtitle, moreTo, moreLabel = "查看更多", icon }: SectionTitleProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-4">
      <div className="min-w-0">
        <h2 className="flex items-center gap-2 font-heading text-lg md:text-xl font-bold text-foreground-950">
          {icon ? (
            <span className="w-6 h-6 flex items-center justify-center text-accent-500">
              <i className={`${icon} text-lg`} />
            </span>
          ) : (
            <span className="w-1 h-5 rounded-full bg-accent-500" />
          )}
          {title}
        </h2>
        {subtitle ? <p className="mt-1 text-[12px] text-foreground-500">{subtitle}</p> : null}
      </div>
      {moreTo ? (
        <Link
          to={moreTo}
          className="shrink-0 text-[12px] text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-0.5"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line" />
        </Link>
      ) : null}
    </div>
  );
}